export type CostumeId = "default" | "costume1" | "costume2" | "costume3";

export type SplashPiece = {
  id: string;
  costume: CostumeId;
  title: string;
  variant: "normal" | "damaged" | "profile" | "sheet";
  src: string;
};

export const costumeLabels: Record<CostumeId, string> = {
  default: "Default",
  costume1: "Repairer of Destiny",
  costume2: "Evening Mist After The Rain",
  costume3: "Magnolia Wonderland",
};

export const splashArt: SplashPiece[] = [
  {
    id: "profile",
    costume: "default",
    title: "Profile",
    variant: "profile",
    src: "/assets/art/splash/mondragon_profile.png",
  },
  {
    id: "default",
    costume: "default",
    title: "Default",
    variant: "normal",
    src: "/assets/art/splash/mondragon.png",
  },
  {
    id: "default-dmg",
    costume: "default",
    title: "Default — damaged",
    variant: "damaged",
    src: "/assets/art/splash/mondragon_damaged.png",
  },
  {
    id: "c1-profile",
    costume: "costume1",
    title: "Repairer of Destiny — profile",
    variant: "profile",
    src: "/assets/art/splash/repairer_of_destiny_profile.png",
  },
  {
    id: "c1",
    costume: "costume1",
    title: "Repairer of Destiny",
    variant: "normal",
    src: "/assets/art/splash/repairer_of_destiny.png",
  },
  {
    id: "c1-dmg",
    costume: "costume1",
    title: "Repairer of Destiny — damaged",
    variant: "damaged",
    src: "/assets/art/splash/repairer_of_destiny_damaged.png",
  },
  {
    id: "c2-profile",
    costume: "costume2",
    title: "Evening Mist After The Rain — profile",
    variant: "profile",
    src: "/assets/art/splash/evening_mist_profile.png",
  },
  {
    id: "c2",
    costume: "costume2",
    title: "Evening Mist After The Rain",
    variant: "normal",
    src: "/assets/art/splash/evening_mist.png",
  },
  {
    id: "c2-dmg",
    costume: "costume2",
    title: "Evening Mist After The Rain — damaged",
    variant: "damaged",
    src: "/assets/art/splash/evening_mist_damaged.png",
  },
  {
    id: "c3-profile",
    costume: "costume3",
    title: "Magnolia Wonderland — profile",
    variant: "profile",
    src: "/assets/art/splash/magnolia_wonderland_profile.png",
  },
  {
    id: "c3",
    costume: "costume3",
    title: "Magnolia Wonderland",
    variant: "normal",
    src: "/assets/art/splash/magnolia_wonderland.png",
  },
  {
    id: "c3-dmg",
    costume: "costume3",
    title: "Magnolia Wonderland — damaged",
    variant: "damaged",
    src: "/assets/art/splash/magnolia_wonderland_damaged.png",
  },
];

export const chibiStills: SplashPiece[] = [
  {
    id: "chibi-default",
    costume: "default",
    title: "Default chibi",
    variant: "normal",
    src: "/assets/art/chibi/mondragon_chibi.png",
  },
  {
    id: "chibi-c1",
    costume: "costume1",
    title: "Repairer of Destiny chibi",
    variant: "normal",
    src: "/assets/art/chibi/repairer_of_destiny_chibi.png",
  },
  {
    id: "chibi-c2",
    costume: "costume2",
    title: "Evening Mist chibi",
    variant: "normal",
    src: "/assets/art/chibi/evening_mist_chibi.png",
  },
  {
    id: "chibi-c3",
    costume: "costume3",
    title: "Magnolia Wonderland chibi",
    variant: "normal",
    src: "/assets/art/chibi/magnolia_wonderland_chibi.png",
  },
];
